const {
  buildSisRedirectUri,
  buildSisTokenParams,
  normalizeTenant,
} = require("./ssoAuth");

const SHIJI_MAIL_PENDING_TENANT_COOKIE = "shiji_mail_pending_tenant";
const SHIJI_MAIL_AUTH_BASE =
  "https://sisstage.shijicloud.com/auth/realms/shiji_shijimini/protocol/openid-connect/auth";

function buildShijiMailAuthUrl({ identityAddress, returnUrl }) {
  const redirectUri = buildSisRedirectUri(identityAddress, returnUrl);

  return (
    `${SHIJI_MAIL_AUTH_BASE}?redirect_uri=${redirectUri}` +
    "&client_id=shijimail&response_type=code&login=true&scope=openid" +
    "&socialLogin=saml"
  );
}

function buildSisTokenRequest(options) {
  const shijiMailTenant = normalizeTenant(options.pendingShijiMailTenant);
  const isShijiMail = Boolean(shijiMailTenant);

  return {
    isShijiMail,
    url: isShijiMail ? options.shijiMailTokenApi : options.sisTokenApi,
    params: buildSisTokenParams({
      code: options.code,
      redirectUri: options.redirectUri,
      ssoTenantName: isShijiMail ? shijiMailTenant : options.ssoTenantName,
    }),
  };
}

function isPendingShijiMailCallback(code, pendingShijiMailTenant) {
  return Boolean(code && normalizeTenant(pendingShijiMailTenant));
}

module.exports = {
  SHIJI_MAIL_PENDING_TENANT_COOKIE,
  buildShijiMailAuthUrl,
  buildSisTokenRequest,
  isPendingShijiMailCallback,
};
